/**
 *
 * Marketing Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { lazyMarketingPage, lazyCreateCampaignpage } from './lazyMarketing';

// routes declaration
export const marketingRoutes = [
  {
    component: lazyMarketingPage,
    title: 'Campaign',
    path: '/campaign',
    needsAuth: true,
  },
  {
    component: lazyCreateCampaignpage,
    title: 'Campaign Post',
    path: '/campaign/post',
    needsAuth: true,
  },
];
